import { useState } from "react";
import {
  Box,
  Typography,
  Tooltip,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { FormikContextType, useFormikContext } from "formik";
import { CopyPromoInitValues } from "./CopyPromotionModal.types";
import { PrizeTableItem } from "../../types/componentTypes/PrizeTypes";

export interface ICopyPromotionPrizeSelection {
  sourcePrizes: PrizeTableItem[]
}

export const CopyPromotionPrizeSelection = ({ sourcePrizes }: ICopyPromotionPrizeSelection) => {
  const formik: FormikContextType<CopyPromoInitValues> = useFormikContext();
  const [selectedPrizes, setSelectedPrizes] = useState<Array<PrizeTableItem>>([]);

  const checkBoxHandler = (event, prize) => {
    const result = event.target.checked ? [...selectedPrizes, prize] : selectedPrizes.filter(item => item.prize_id !== prize.prize_id)
    setSelectedPrizes(result);
    formik.setFieldValue('tempParams.prizes', result);
  }

  const getPrizeLabel = (prize) => {
    return `${Object.values(JSON.parse(prize.name))} (${prize.prize_id})`;
  }

  return (
    <Box sx={{ mt: 1 }}>
      <Box display="flex" alignItems="center" mb={1}>
        <Typography variant="subtitle1" component="legend">
          Select Prize to Copy
        </Typography>
        <Tooltip title="By default, the copied prize will be created as not available for distribution.">
          <InfoIcon
            sx={{ ml: 1, color: "action.active", fontSize: "1rem" }}
          />
        </Tooltip>
      </Box>
      {!sourcePrizes.length && (
        <Typography variant="body1" mx={2}>
          No prizes found in the selected promotion or failed to load.
        </Typography>
      )}
      {sourcePrizes.length > 0 && sourcePrizes.map((prize, index) => (
        <Box key={`copy-promo-prize-${index}`}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{ mx: 1 }}
                size={'medium'}
                className='checkbox-class'
                data-testid={`copy-promo-prize-${prize.prize_id}`}
                id={`copy-promo-prize-${prize.prize_id}`}
                name={`copy-promo-prize-${prize.prize_id}`}
                onChange={(e) => checkBoxHandler(e, prize)}
              />
            }
            label={getPrizeLabel(prize)}
          />
        </Box>

      )
      )}
    </Box>
  );
};